export default "__VITE_ASSET__fde7d6d2__"